import { render } from "./cta.vue?vue&type=template&id=39f258fd&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=39f258fd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39f258fd"

export default script